// extracted by mini-css-extract-plugin
export var container = "_d0-0";
export var infoIcon = "_d0-2";
export var titleRowCol = "_d0-1";